import { BigFormRow, FormRow, FormSection, MediumFormRow } from 'framework/ui/layout';
import { Checkbox, CountryDropdown, InputList, PhoneInput, TextArea, TextInput, LegalEntityEnum } from 'framework/form';
import useLedgerService from 'domain/finance/ledger/useLedgerService';
import { AccountInput } from 'domain/shared/ledger';
import VendorsContactInputs from '../shared/inputs/VendorContactsInput/VendorsContactInputs';

const ComplianceVendorForm = () => {
  const { searchInvoiceAccount } = useLedgerService();
  return (
    <>
      <FormSection title="">
        <FormRow>
          <TextInput source="vendorName" label="" placeholder="Vendor name" />
          <CountryDropdown label="" placeholder="Vendor country" source="country" />

          <TextInput label="" placeholder="Tax registration number" source="taxRegistrationNumber" />
          <AccountInput
            source="costCenterId"
            label=""
            placeholder="Cost center"
            cacheKey="vendor-accounts"
            loadDataMethod={searchInvoiceAccount}
          />
        </FormRow>

        <FormRow>
          <LegalEntityEnum source="agreementDetails.legalEntity" label="" placeholder="Legal entity" />
          <Checkbox source="isDataProcessor" label="Is data processor?" />
          <Checkbox disabled source="isCompliant" label="Is vendor compliant?" />
          <Checkbox source="isAutoApproved" label="Performance review and agreement extending is not needed" />
        </FormRow>

        <BigFormRow>
          <TextArea source="purpose" placeholder="Purpose" label="" />
        </BigFormRow>
      </FormSection>

      <MediumFormRow>
        <FormSection title="Contacts">
          <BigFormRow>
            <MediumFormRow>
              <PhoneInput label="" placeholder="General vendor phone" source="phoneNumber" />
              <TextInput label="" placeholder="General vendor email" source="email" />
            </MediumFormRow>

            <InputList
              defaultValue={{
                name: '',
                phoneNumber: '',
                email: '',
              }}
              maxFields={3}
              inputTemplate={VendorsContactInputs}
              source="contacts"
            />
          </BigFormRow>
        </FormSection>
      </MediumFormRow>
    </>
  );
};

export default ComplianceVendorForm;
